// Use environment variable if available, otherwise default to localhost for development
export const websocketPort = process.env.REACT_APP_WEBSOCKETPORT || 'http://localhost:3002';
//DEV: 'http://localhost:3002' or PROD: "https://unified.cascais.dev-dttsynergy.com:443";